import * as ChapterType from "utils/ChapterType";
import * as HotspotTargetType from "utils/HotspotTargetType";
import { createSelector } from "reselect";
import { parse as parseUrl } from "url";
import getAllChapters from "./getAllChapters";
import makeGetHotspot from "./makeGetHotspot";

export function getCallToAction(targetType, hotspot) {
  let callToAction;
  switch (targetType) {
    case ChapterType.VIDEO:
      callToAction = "Watch";
      break;
    case ChapterType.LINK:
      callToAction = `Go to ${parseUrl(hotspot.target.target).host}`;
      break;
    case HotspotTargetType.EXTERNAL_CALLBACK:
      callToAction = "View";
      break;
    default:
      callToAction = "Explore";
      break;
  }
  return callToAction;
}

export function getHotspotCallToAction(allChapters, hotspot) {
  let targetType;

  if (hotspot.target.type === HotspotTargetType.CHAPTER) {
    targetType = allChapters[hotspot.target.chapterId].type;
  } else if (hotspot.target.type === HotspotTargetType.LINK) {
    targetType = ChapterType.LINK;
  } else if (hotspot.target.type === HotspotTargetType.NONE) {
    targetType = "none";
  } else if (hotspot.target.type === HotspotTargetType.EXTERNAL_CALLBACK) {
    targetType = HotspotTargetType.EXTERNAL_CALLBACK;
  }

  return getCallToAction(targetType, hotspot);
}

export default function makeGetHotspotCallToAction() {
  const getHotspot = makeGetHotspot();
  return createSelector([getAllChapters, getHotspot], getHotspotCallToAction);
}
